import { MenuLink, MenuLinkProps } from '@reach/menu-button';
import classnames from 'classnames';
import React from 'react';

import I18n from '@wetransfer/transfer/modules/i18n';
import { Pill } from '@wetransfer/transfer/oneui/react';

import '../AccountMenuItem/AccountMenuItem.scss';

export type Props = MenuLinkProps & {
  href: string;
  external?: boolean;
  active?: boolean;
  isNewFeature?: boolean;
  isBetaFeature?: boolean;
  onSelect?: () => void;
};

export const AccountMenuLink: React.FC<Props> = ({
  href,
  external = false,
  children,
  active = false,
  isNewFeature = false,
  isBetaFeature = false,
  onSelect,
  ...props
}) => {
  const getPillText = () => {
    if (isBetaFeature) {
      return I18n.t('navigation.label.beta');
    }

    if (isNewFeature) {
      return I18n.t('navigation.label.new');
    }
  };

  const getPillColor = () => {
    if (isBetaFeature) {
      return 'sun';
    }

    if (isNewFeature) {
      return 'success';
    }
  };

  const showPill = isBetaFeature || isNewFeature;

  return (
    <MenuLink
      className={classnames('AccountMenuItem', {
        'AccountMenuItem--active': active,
      })}
      href={href}
      onSelect={onSelect}
      target={external ? '_blank' : null}
      rel={external ? 'noopener noreferrer' : null}
      {...props}
    >
      {children}
      {showPill && (
        <Pill
          textContent={getPillText()}
          variant={getPillColor()}
          shape="square"
          size="small"
          className="AccountMenuItem--pill"
        />
      )}
    </MenuLink>
  );
};
